// Frontend copy of the audit action labels (kept in sync with backend audit-log.ts).
// Do not import backend types here — frontend and backend are separate bundles.

export const PROC_AUDIT_ACTION_LABELS: Record<string, string> = {
  instance_created: 'Prozess gestartet',
  instance_cancelled: 'Prozess abgebrochen',
  instance_completed: 'Prozess abgeschlossen',
  instance_rejected: 'Prozess abgelehnt',
  step_started: 'Schritt gestartet',
  step_completed: 'Schritt abgeschlossen',
  step_rejected: 'Schritt abgelehnt',
  step_skipped: 'Schritt übersprungen',
  approval_granted: 'Freigabe erteilt',
  approval_rejected: 'Freigabe abgelehnt',
  approval_delegated: 'Freigabe delegiert',
  form_submitted: 'Formular eingereicht',
  assignment_changed: 'Zuweisung geändert',
  context_updated: 'Kontext aktualisiert',
  due_date_changed: 'Fälligkeitsdatum geändert',
  note_added: 'Notiz hinzugefügt',
}
